$(function() {

  var owl = $('.results-slider');

  /*
  owl.on('initialized.owl.carousel', function(event) {
    carouselInitialized();

  });
  */

  owl.owlCarousel({
    center: true,
    items:1,
    loop:false,
    nav: true,
    onInitialized: carouselInitialized,
    margin:10,
    responsive:{
      0:{
        items:1,
        nav: false
      },
      600:{
        items:2,
        nav: true
      }
    }
  });



});

function carouselInitialized() {

  var dots = $('.owl-dots .owl-dot');
  console.log(dots.length);
  for (let i = 0; i < dots.length; i++) {
    var e = dots[i];
    var month_num = i + 1;
    console.log(e);
    //$(e).wrap( "<div class='dots-label'></div>" );

    //$(e).parent( ".dots-label" ).append( "<div class='month-label'>Month " + month_num + "</div>" );
    $(e).find('span').text("Month " + month_num );


  }

}

function incrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal)) {
    parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}

function decrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal) && currentVal > 0) {
    parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}

$('.input-group').on('click', '.button-plus', function(e) {
  incrementValue(e);
});

$('.input-group').on('click', '.button-minus', function(e) {
  decrementValue(e);
});